module.exports = __webpack_public_path__ + "static/media/biggroup.26eccff7.svg";